export { default } from './ReviewsPagination'
